import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { ResellerPlace } from 'domains/reseller-place';

export const getResellerPlace: QueryFunction<ResellerPlace> = async () => {
  return (await api.get('/reseller/places').then((resp) => resp.data)) as ResellerPlace;
};
